/**
 * 资源加载器模块
 * 提供动态加载 CSS 和 JavaScript 资源的功能
 * 
 * @module common/utils/resourceLoader
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 资源加载器对象
   * @namespace resourceLoader
   */
  common.resourceLoader = {
    /**
     * 加载 CSS 资源
     * @param {string} url - CSS文件URL
     * 
     * @example
     * watashi.common.resourceLoader.loadCss('/path/to/style.css');
     */
    loadCss: function (url) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      document.head.appendChild(link);
    },

    /**
     * 加载 JavaScript 资源
     * @param {string} url - JS文件URL
     * 
     * @example
     * watashi.common.resourceLoader.loadJs('/path/to/script.js');
     */
    loadJs: function (url) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.head.appendChild(script);
    },
  };

})(typeof window !== "undefined" ? window : this);
